import axios from '../../axios'

/*
 * 教师版志愿机构合作方数据接口
 */

// 获取教师版志愿机构合作方列表
export const getAllPartnersList = (data) => {
    return axios({
        url: '/api/base/teacher/partners/list',
        method: 'get',
        data
    })
}

// 获取教师版志愿机构合作方列表
export const getPartnersList = (data) => {
    return axios({
        url: '/api/base/teacher/partners',
        method: 'get',
        data
    })
}

// 新增教师版志愿机构合作方信息
export const savePartners = (data) => {
    return axios({
        url: '/api/base/teacher/partners',
        method: 'post',
        data
    })
}

// 编辑教师版志愿机构合作方信息
export const updatePartners = (data) => {
    return axios({
        url: '/api/base/teacher/partners',
        method: 'put',
        data
    })
}

// 删除教师版志愿机构合作方列表
export const deletePartners = (data) => {
    return axios({
        url: '/api/base/teacher/partners',
        method: 'delete',
        data
    })
}
// 获取机构限制次数列表
export const getLimitCountList = (data) => {
    return axios({
        url: '/api/admin/teacher/report/limit/page',
        method: 'get',
        data
    })
}

// 更新编辑机构限制次数
export const changeLimitCount = (data) => {
    return axios({
        url: '/api/admin/teacher/report/limit/save',
        method: 'put',
        data
    })
}


// 获取教师版机构剩余客单
export const getPartnersLimitCount = (data) => {
    return axios({
        url: '/api/admin/wish/report/limit/count/by/id',
        method: 'get',
        data
    })
}



// 获取模拟考机构合作方信息
export const getAllProvincePartners = (data) => {
    return axios({
        url: '/api/base/province/partners/list',
        method: 'get',
        data
    })
}

// 删除模拟考机构合作方信息
export const deleteProvincePartners = (data) => {
    return axios({
        url: '/api/base/province/partners',
        method: 'delete',
        data
    })
}

// 更新编辑模拟考机构合作方信息
export const updateProvincePartners = (data) => {
    return axios({
        url: '/api/base/province/partners',
        method: 'put',
        data
    })
}

// 新增模拟考机构合作方信息
export const addProvincePartners = (data) => {
    return axios({
        url: '/api/base/province/partners',
        method: 'post',
        data
    })
}

// 分页获取模拟考机构合作方信息
export const getProvincePartnersPage = (data) => {
    return axios({
        url: '/api/base/province/partners',
        method: 'get',
        data
    })
}

// 导出模拟考机构合作方信息
export const exportProvincePartners = (data) => {
    return axios({
        url: '/api/base/province/partners/export',
        method: 'post',
        data
    })
}

// 批量更新模拟考机构合作方信息
export const batchUpdateProvincePartners = (data) => {
    return axios({
        url: '/api/base/province/partners/batch/update',
        method: 'post',
        data
    })
}
// 获取志愿机构合作方信息
export const getAllWishPartners = (data) => {
    return axios({
        url: '/api/base/wish/partners/list',
        method: 'get',
        data
    })
}

// 删除志愿机构合作方信息
export const deleteWishPartners = (data) => {
    return axios({
        url: '/api/base/wish/partners',
        method: 'delete',
        data
    })
}

// 更新编辑志愿机构合作方信息
export const updateWishPartners = (data) => {
    return axios({
        url: '/api/base/wish/partners',
        method: 'put',
        data
    })
}

// 新增志愿机构合作方信息
export const addWishPartners = (data) => {
    return axios({
        url: '/api/base/wish/partners',
        method: 'post',
        data
    })
}

// 分页获取志愿机构合作方信息
export const getWishPartnersPage = (data) => {
    return axios({
        url: '/api/base/wish/partners',
        method: 'get',
        data
    })
}

// 导出志愿机构合作方信息
export const exportWishPartners = (data) => {
    return axios({
        url: '/api/base/wish/partners/export',
        method: 'post',
        data
    })
}

// 批量更新模拟考机构合作方信息
export const batchUpdateWishPartners = (data) => {
    return axios({
        url: '/api/base/wish/partners/batch/update',
        method: 'post',
        data
    })
}

// 分页获取达人直播间信息
export const getWishPartnersRoomPage = (data) => {
    return axios({
        url: '/api/base/wish/partners/room',
        method: 'get',
        data
    })
}
// 删除达人信息
export const deleteWishPartnersRoomPage = (data) => {
    return axios({
        url: '/api/base/wish/partners/room',
        method: 'delete',
        data
    })
}

// 更新编辑达人信息
export const updateWishPartnersRoomPage = (data) => {
    return axios({
        url: '/api/base/wish/partners/room',
        method: 'put',
        data
    })
}
// 新增达人信息
export const addWishPartnersRoomPage = (data) => {
    return axios({
        url: '/api/base/wish/partners/room',
        method: 'post',
        data
    })
}

// 获取达人商品信息
export const getUserProducts = (data) => {
    return axios({
        url: '/api/base/goods',
        method: 'get',
        data
    })
}

// ID获取达人商品信息
export const getUserProductsById = (data) => {
    return axios({
        url: '/api/base/live/room/goods/page',
        method: 'get',
        data
    })
}

// 新增达人商品信息
export const addUserProducts = (data) => {
    return axios({
        url: '/api/base/live/room/goods',
        method: 'post',
        data
    })
}

// 编辑达人商品信息
export const updateUserProducts = (data) => {
    return axios({
        url: '/api/base/live/room/goods',
        method: 'put',
        data
    })
}

// 删除达人商品信息
export const deleteUserProducts = (data) => {
    return axios({
        url: '/api/base/live/room/goods/delete',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/partners.js